import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth, hasRole } from '../lib/auth.jsx';

export function AppShell({ children }) {
  const { t, i18n } = useTranslation();
  const { user, logout } = useAuth();

  const setLang = l => {
    i18n.changeLanguage(l);
    localStorage.setItem('lang', l);
  };

  return (
    <div className="app">
      <aside className="sidebar">
        <div className="brand">
          <div className="brand-dot" />
          <div className="brand-name">{t('app.name')}</div>
        </div>

        <NavLink to="/" end className="nav-item">{t('nav.dashboard')}</NavLink>
        <NavLink to="/invoices" className="nav-item">{t('nav.invoices')}</NavLink>
        <NavLink to="/quotes" className="nav-item">{t('nav.quotes')}</NavLink>
        <NavLink to="/proformas" className="nav-item">{t('nav.proformas')}</NavLink>
        <NavLink to="/credit-notes" className="nav-item">{t('nav.creditNotes')}</NavLink>
        <NavLink to="/payments" className="nav-item">{t('nav.payments')}</NavLink>
        <NavLink to="/expenses" className="nav-item">Expenses</NavLink>
        <NavLink to="/recurring" className="nav-item">Recurring</NavLink>
        <NavLink to="/import" className="nav-item">Import</NavLink>

        <div className="nav-section">{t('nav.catalog')}</div>
        <NavLink to="/clients" className="nav-item">{t('nav.clients')}</NavLink>
        <NavLink to="/articles" className="nav-item">{t('nav.articles')}</NavLink>
        <NavLink to="/categories" className="nav-item">{t('nav.categories')}</NavLink>

        <div className="nav-section">{t('nav.reports')}</div>
        <NavLink to="/reports" className="nav-item">{t('nav.reports')}</NavLink>

        {hasRole(user, 'ADMIN') && (
          <>
            <div className="nav-section">{t('nav.settings')}</div>
            <NavLink to="/settings/company" className="nav-item">{t('nav.company')}</NavLink>
            <NavLink to="/settings/series" className="nav-item">{t('nav.series')}</NavLink>
            <NavLink to="/settings/vat" className="nav-item">{t('nav.vat')}</NavLink>
            <NavLink to="/settings/currencies" className="nav-item">{t('nav.currencies')}</NavLink>
            <NavLink to="/settings/users" className="nav-item">{t('nav.users')}</NavLink>
            <NavLink to="/settings/email" className="nav-item">Email</NavLink>
            <NavLink to="/settings/audit" className="nav-item">Audit log</NavLink>
          </>
        )}
      </aside>

      <main className="main">
        <div className="topbar">
          <div />
          <div className="user">
            <select value={i18n.language} onChange={e => setLang(e.target.value)} style={{ padding: '4px 8px' }}>
              <option value="en">EN</option>
              <option value="sq">SQ</option>
            </select>
            <span>{user?.name}</span>
            <span className={`badge badge-${user?.role.toLowerCase()}`}>{t(`roles.${user?.role}`)}</span>
            <button className="btn btn-secondary btn-sm" onClick={logout}>{t('nav.logout')}</button>
          </div>
        </div>
        <div className="content">{children}</div>
      </main>
    </div>
  );
}
